import { render, staticRenderFns } from "./SanctionAssign.vue?vue&type=template&id=0bd130c8"
import script from "./SanctionAssign.vue?vue&type=script&lang=js"
export * from "./SanctionAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports